module.exports = __webpack_public_path__ + "static/img/dezhou-index.7423db6e.jpg";